var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.investmentEntities.length > 1)?_c('div',_vm._l((_vm.investmentEntities),function(investmentEntity){return _c('NavInvestmentEntityListItem',{key:investmentEntity.investmentEntityId,attrs:{"entity":investmentEntity}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }